// extracted by mini-css-extract-plugin
export default {"loading-root":"Loading_loading-root__HSnBj","center":"Loading_center__yUaTu","loading":"Loading_loading__cHnX2"};